<template>
  <div>
    <div class="container">
      <div class="row mt-20">
        <div
          class="col-md-3 repair-box-item repair-box-item--cat"
          v-for="category in categories"
          :key="category._id"
        >
          <router-link tag="a" :to="getPath(category.slug)">
            <img
              :src="`/img/cats/${category.slug}.jpg`"
              :alt="category.name"
              :title="category.name"
              :data-fallback="`https://placehold.co/400?text=${category.name}`"
              onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
            />
            <span class="repair-box-item__title">{{ category.name }}</span>
          </router-link>
        </div>
      </div>
      <div class="row mt-20">
        <div class="container">
          <div class="col-md-12">
            <div class="h2 text-center bold">{{ $t('repairPage.title') }}</div>
            <div v-html="$t('repairPage.paragraph')"></div>
          </div>
          <div class="col-md-12">
            <RepairServiceSimpleForm />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RepairServiceSimpleForm from '@/components/repair/RepairServiceSimpleForm'

export default {
  name: 'RepairService',
  components: {
    RepairServiceSimpleForm,
  },
  computed: {
    ...mapState(['repair']),
    categories() {
      return this.repair.categories
    },
  },
  methods: {
    getPath(slug) {
      return `${this.lang ? `/${this.lang}` : ''}/service/${slug}`
    },
  },
}
</script>

<style>
.repair-box-item {
  margin-top: 15px;
}
@media only screen and (max-width: 600px) {
  .repair-box-item {
    padding-right: 5px;
    padding-left: 5px;
  }
  .repair-box-item--cat {
    padding: 0 40px;
  }
}
.repair-box-item img {
  border-radius: 15px;
  width: 100%;
}
.repair-box-item a {
  display: block;
}

.repair-box-item__title {
  text-align: center;
  display: block;
  padding: 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
